import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getCaseDetailsActions,
  pickCaseDetailsState,
} from "../util/resolveCaseDetailsActions";

const useCaseDetailsContext = () => {
  const { pathname } = useLocation();
  const caseDetailsReducer = useSelector((state) => state.caseDetailsReducer);
  const actions = useMemo(() => getCaseDetailsActions(pathname), [pathname]);
  const state = useMemo(
    () => pickCaseDetailsState(caseDetailsReducer, pathname),
    [caseDetailsReducer, pathname]
  );

  return {
    pathname,
    actions,
    ...state,
  };
};

export default useCaseDetailsContext;
